var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 12.0603L11.3127 14.0596C11.8354 14.375 12.4801 13.9063 12.3414 13.3123L11.4621 9.54362L14.3894 7.00762C14.8507 6.60828 14.6041 5.85028 13.9961 5.79895L10.1427 5.47228L8.63541 1.91562C8.39741 1.35495 7.60274 1.35495 7.36474 1.91562L5.85741 5.47228L2.00407 5.79895C1.39607 5.85028 1.14941 6.60828 1.61074 7.00762L4.53807 9.54362L3.65874 13.3123C3.52007 13.9063 4.16474 14.375 4.68741 14.0596L8.00008 12.0603Z",
    fill: "#FAAC38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.f3b8cf0487291750621c8057c667028a.svg";
export { ForwardRef as ReactComponent };